import { useState } from "react";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import ValidToast from "../toasts/ValidToast";
import UnvalidToast from "../toasts/UnvalidToast";
import { trocRequestCancel } from "../../services/callAPI/trocsRequests";

interface ICancelRequestModalProps {
  id: number;
  trocTId: number,
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>
}

function CancelRequestModal(props: ICancelRequestModalProps) {
  //destructuring
  const { id, trocTId, setTrigUseEffect } = props;

  const [openModal, setOpenModal] = useState(false);

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  const [errorMsg, seterrorMsg] = useState<string | undefined>(undefined);

  async function handleTrocRequestCancellation(id: number, trocTId: number) {
    try {
      //call API
      const response = await trocRequestCancel(id, trocTId);

      if (response.status === 204) {
        //show ValidToast
        setIsShowValidToast(true);

        //update table troc Request
        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 2000);
      }
      else {
        throw new Error(`Le statut de la response n'est pas 204`);
      }
    }
    catch (error) {
      if (error instanceof Error) {
        seterrorMsg(error.message);
      }

      //show UnvalidToast
      setIsShowUnvalidToast(true);

      setTimeout(() => {
        setTrigUseEffect(prev => !prev);
      }, 3000);
    }
  }

  return (
    <>
      {isShowValidToast && <ValidToast onClose={() => setIsShowValidToast(false)} />}
      {isShowUnvalidToast &&
        <UnvalidToast
          message={errorMsg}
          onClose={() => {
            setIsShowUnvalidToast(false);
            seterrorMsg(undefined)
          }}
        />
      }

      <button className="w-1/3 max-w-52 bg-redCustom rounded-md py-1 text-white mr-auto" onClick={() => setOpenModal(true)}>Annuler ma demande</button>

      <Modal show={openModal} className="bg-transparent" size="md" onClose={() => setOpenModal(false)} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-lightRedCustom dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-greenCustom dark:text-greenCustom">
              Je veux annuler ma demande de troc ?
            </h3>
            <div className="flex justify-center gap-4 pb-8">
              <Button className="bg-greenCustom text-white flex-1" onClick={() => { setOpenModal(false), handleTrocRequestCancellation(id, trocTId) }}>
                Oui
              </Button>
              <Button className="bg-lightRedCustom text-white flex-1" onClick={() => setOpenModal(false)}>
                Non
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default CancelRequestModal;